var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPartnerProgramOverview = function SvgPartnerProgramOverview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2455 9.13C15.4909 10.06 16.3637 11.32 16.3637 13V16H20V13C20 10.82 16.7546 9.53 14.2455 9.13Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7273 8C14.7364 8 16.3636 6.21 16.3636 4C16.3636 1.79 14.7364 0 12.7273 0C12.3 0 11.9 0.0999998 11.5182 0.24C12.2727 1.27 12.7273 2.58 12.7273 4C12.7273 5.42 12.2727 6.73 11.5182 7.76C11.9 7.9 12.3 8 12.7273 8Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27272 8C9.28181 8 10.9091 6.21 10.9091 4C10.9091 1.79 9.28181 0 7.27272 0C5.26363 0 3.63635 1.79 3.63635 4C3.63635 6.21 5.26363 8 7.27272 8ZM7.27272 2C8.27272 2 9.0909 2.9 9.0909 4C9.0909 5.1 8.27272 6 7.27272 6C6.27272 6 5.45453 5.1 5.45453 4C5.45453 2.9 6.27272 2 7.27272 2Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27273 9C4.84545 9 0 10.34 0 13V16H14.5455V13C14.5455 10.34 9.7 9 7.27273 9ZM12.7273 14H1.81818V13.01C2 12.29 4.81818 11 7.27273 11C9.72727 11 12.5455 12.29 12.7273 13V14Z",
    fill: "black",
    fillOpacity: 0.7
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartnerProgramOverview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partnerProgramOverview.7baf3b2d.svg";
export { ForwardRef as ReactComponent };